module.exports = __webpack_public_path__ + "static/21-4dfb8d92c5f5437c654671590c16481a.jpg";